<template>
    <el-container style="width:100%">
        <el-header style="height:100px">
            <el-form :inline="true" :model="fromDeviceProtcol" ref="fromDeviceProtcol" class="demo-form-inline">
                <el-row :gutter="20">
                    <el-col :span="24" v-show="queryShow">
                        <el-form-item :label="$t('common.PROTCOL_NAME')" prop="protcolName">
                            <td-input v-model="fromDeviceProtcol.protcolName" :maxlength="500"></td-input>
                        </el-form-item>
                        <el-form-item :label="$t('common.PROTCOL_ID')" prop="protcolId">
                            <td-input v-model="fromDeviceProtcol.protcolId" :maxlength="500"></td-input>
                        </el-form-item>
                        <el-form-item :label="$t('common.PROTCOL_GROUP_NAME')" prop="groupCaption">
                            <td-select v-model="fromDeviceProtcol.groupCaption" keys="ctlGroupId" text="ctlGroupName" :options="groupCaptionList" :clearable="false"></td-select>
                        </el-form-item>
                        <el-form-item :label="$t('common.CONTROL_TYPE')" prop="controlType">
                            <td-select v-model="fromDeviceProtcol.controlType" :options="controlTypeList" :clearable="false"></td-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item :label="$t('common.OPERATE_TYPE')" prop="operateType" v-show="queryShow">
                            <td-select v-model="fromDeviceProtcol.operateType" :options="operateTypeList" :clearable="false"></td-select>
                        </el-form-item>
                        <el-form-item>
                            <td-button type="primary" :permissions="permissionsQuery" @getPermissionsStatus="getPermissionsStatus" :loading="loading" @click="btnQuery">{{
                                $t('common.QUERY')
                            }}</td-button>
                            <td-button type="button" :permissions="permissionsImport" @click="btnImport">{{ $t('common.PROTCOL') }}{{ $t('common.IMPORT') }}</td-button>
                            <td-button type="button" :permissions="permissionsExport" @click="btnExport">{{ $t('common.PROTCOL') }}{{ $t('common.EXPORT') }}</td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :dataSource="tableData"
                :pageSize="pageSize"
                :hasMutiSelect="false"
                :currentPage="currentPage"
                :total="total"
                :rowKey="rowKey"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                :hasLoading="hasLoading"
                v-show="queryShow"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-protcolExport v-if="dialogExportVisible" :dialogExportVisible="dialogExportVisible" :title="exportTitle" @protExdialogClose="protExdialogClose"></dialog-protcolExport>
            <dialog-protcolImport v-if="dialogImportVisible" :dialogImportVisible="dialogImportVisible" :title="importTitle" @protIndialogClose="protIndialogClose"></dialog-protcolImport>
            <dialog-protcol v-if="dialogProtVisible" :dialogProtVisible="dialogProtVisible" :editItem="editItem" :title="protTitle" @protcolDialogClose="protcolDialogClose"></dialog-protcol>
            <dialog-protTest
                v-if="dialogProtTestVisible"
                :dialogProtTestVisible="dialogProtTestVisible"
                :editItem="editItemTest"
                :title="testTitle"
                @protTestDialogClose="protTestDialogClose"
            ></dialog-protTest>
        </el-main>
    </el-container>
</template>

<script>
import Api from './assets/api.js';
import dialogProtcolExport from './components/dialogProtcolExport.vue';
import dialogProtcolImport from './components/dialogProtcolImport.vue';
import dialogProtDetail from './components/dialogProtDetail.vue';
import dialogProtTest from './components/dialogProtTest.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-protcolExport': dialogProtcolExport,
        'dialog-protcolImport': dialogProtcolImport,
        'dialog-protcol': dialogProtDetail,
        'dialog-protTest': dialogProtTest
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.fromDeviceProtcol.operateType = this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_ALL;
        this.fromDeviceProtcol.controlType = this.$common.deviceControlType.CTL_MODE_TYPE_ALL;
        this.initSelect();
    },
    // 定义数据
    data() {
        return {
            permissionsQuery: ['devCtrlProt:view'],
            permissionsImport: ['devCtrlProt:import'],
            permissionsExport: ['devCtrlProt:export'],
            fromDeviceProtcol: { protcolId: '', protcolName: '', operateType: '', controlType: '', groupCaption: '' },
            // 操作类型
            operateTypeList: [
                {
                    value: this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_ALL,
                    label: this.$t('common.ALL')
                },
                {
                    value: this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_CONTROL,
                    label: this.$t('common.CONTROL')
                },
                {
                    value: this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_DOWNLOAD,
                    label: this.$t('common.DOWNLOAD')
                },
                {
                    value: this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_QUERY,
                    label: this.$t('common.QUERY')
                },
                {
                    value: this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_UPLOAD,
                    label: this.$t('common.UPLOAD')
                },
                {
                    value: this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_CONFIG,
                    label: this.$t('common.ALLOCATION')
                }
            ],
            // 控制类型
            controlTypeList: [
                {
                    value: this.$common.deviceControlType.CTL_MODE_TYPE_ALL,
                    label: this.$t('common.ALL')
                },
                {
                    value: this.$common.deviceControlType.CTL_MODE_SIMPLE,
                    label: this.$t('common.CTL_MODE_SIMPLE')
                },
                {
                    value: this.$common.deviceControlType.CTL_MODE_DOUBLE_STREAM,
                    label: this.$t('common.CTL_MODE_DOUBLE_STREAM')
                },
                {
                    value: this.$common.deviceControlType.CTL_MODE_SERVER_STREAM,
                    label: this.$t('common.CTL_MODE_SERVER_STREAM')
                },
                {
                    value: this.$common.deviceControlType.CTL_MODE_CLIENT_STREAM,
                    label: this.$t('common.CTL_MODE_CLIENT_STREAM')
                }
            ],
            rowKey: 'ctlProtId',
            groupCaptionList: [],
            editItem: '',
            editItemTest: '',
            dialogExportVisible: false,
            dialogImportVisible: false,
            dialogProtVisible: false,
            dialogProtTestVisible: false,
            tableData: [],
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            hasLoading: false,
            columns: [
                {
                    prop: 'ctlProtId',
                    label: 'common.PROTCOL_ID'
                },
                {
                    prop: 'ctlProtName',
                    label: 'common.PROTCOL_NAME'
                },
                {
                    prop: 'ctlGroupName',
                    label: 'common.PROTCOL_GROUP'
                },
                {
                    prop: 'protMode',
                    label: 'common.OPERATE_TYPE',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('label', this.transferProtModeType(params.row));
                    }
                },
                {
                    prop: 'ctlMode',
                    label: 'common.PROTCOL_CONTROL_TYPE',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('label', this.transferCtrlModeType(params.row));
                    }
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDetail(params.row);
                                        }
                                    }
                                },
                                this.$t('common.DETAIL')
                            ),
                            createElement(
                                'el-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnTestMethod(params.row);
                                        }
                                    }
                                },
                                this.$t('common.PROT_TEST')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 根据id显示对应的协议模式
        transferProtModeType(row) {
            if (row.protMode == this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_CONTROL) {
                return this.$t('common.CONTROL');
            } else if (row.protMode == this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_DOWNLOAD) {
                return this.$t('common.DOWNLOAD');
            } else if (row.protMode == this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_QUERY) {
                return this.$t('common.QUERY');
            } else if (row.protMode == this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_UPLOAD) {
                return this.$t('common.UPLOAD');
            } else if (row.protMode == this.$common.deviceOperateType.DEVICE_OPERATE_TYPE_CONFIG) {
                return this.$t('common.ALLOCATION');
            } else {
                return this.$t('common.NOT_CONFIG');
            }
        },
        // 根据id显示对应的控制模式
        transferCtrlModeType(row) {
            if (row.ctlMode == this.$common.deviceControlType.CTL_MODE_SIMPLE) {
                return this.$t('common.CTL_MODE_SIMPLE');
            } else if (row.ctlMode == this.$common.deviceControlType.CTL_MODE_DOUBLE_STREAM) {
                return this.$t('common.CTL_MODE_DOUBLE_STREAM');
            } else if (row.ctlMode == this.$common.deviceControlType.CTL_MODE_SERVER_STREAM) {
                return this.$t('common.CTL_MODE_SERVER_STREAM');
            } else if (row.ctlMode == this.$common.deviceControlType.CTL_MODE_CLIENT_STREAM) {
                return this.$t('common.CTL_MODE_CLIENT_STREAM');
            } else {
                return this.$t('common.NOT_CONFIG');
            }
        },
        initSelect() {
            let all = {
                ctlGroupId: -1,
                ctlGroupName: this.$t('common.ALL')
            };
            Api.getProtGroupList('{}', response => {
                if (response === null || response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('devCtlProt/getProtGroupList', response);
                    return;
                }
                if (response.data.statusCode !== this.$t('common.REQUEST_SUCCESS')) {
                    this.$log.error('devCtlProt/getProtGroupList', response.data.statusMessage);
                    return;
                }
                response.data.content.unshift(all);
                this.groupCaptionList = response.data.content;
            });
            this.fromDeviceProtcol.groupCaption = -1;
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.submit();
        },
        //页面权限设置
        getPermissionsStatus(permissions) {
            if (permissions) {
                this.queryShow = true;
                this.btnQuery(); // 进行页面初始化数据的加载
            } else {
                this.queryShow = false;
            }
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        // 查询数据
        btnQuery() {
            this.currentPage = 1;
            this.queryList();
        },
        // 查询数据
        queryList() {
            this.loading = true;
            this.hasLoading = true;
            let protGroupId = '';
            if (this.fromDeviceProtcol.groupCaption !== -1) {
                protGroupId = this.fromDeviceProtcol.groupCaption;
            }
            let param = {
                protId: this.fromDeviceProtcol.protcolId,
                protCaption: this.fromDeviceProtcol.protcolName,
                operateType: this.fromDeviceProtcol.operateType,
                controlType: this.fromDeviceProtcol.controlType,
                protGroupId: protGroupId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                pageFlag: true
            };
            Api.queryProtList(param, response => {
                this.hasLoading = false;
                if (response === null || response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    this.$log.error('devCtlProt/getProtGroupList', response);
                    this.loading = false;
                    return;
                }
                if (response.data.statusCode !== this.$t('common.REQUEST_SUCCESS')) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('devCtlProt/getProtGroupList', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 详细
        btnDetail(row) {
            this.editItem = row;
            this.protTitle = this.$t('common.DETAIL');
            this.dialogProtVisible = true;
        },
        //调试测试
        btnTestMethod(param) {
            this.editItemTest = param;
            this.testTitle = this.$t('common.PROT_TEST');
            this.dialogProtTestVisible = true;
        },
        // 导出
        btnExport() {
            this.exportTitle = this.$t('common.PROTCOL') + this.$t('common.EXPORT');
            this.dialogExportVisible = true;
        },
        // 导入
        btnImport() {
            this.importTitle = this.$t('common.PROTCOL') + this.$t('common.IMPORT');
            this.dialogImportVisible = true;
        },
        // 组件关闭需要调用的方法
        submit() {
            this.queryList();
        },
        // 关闭页面
        protExdialogClose() {
            this.dialogExportVisible = false;
        },
        // 关闭详细页面
        protcolDialogClose() {
            this.dialogProtVisible = false;
        },
        // 关闭导入页面
        protIndialogClose() {
            this.dialogImportVisible = false;
            this.initSelect();
        },
        // 关闭调试页面
        protTestDialogClose() {
            this.dialogProtTestVisible = false;
        }
    }
};
</script>
